import { useMemo } from 'react';
import { useFetchUserInfo } from './useFetchUserInfo';
export const useHasGate = gate => {
  const userInfoResult = useFetchUserInfo();
  return useMemo(() => Object.assign({}, userInfoResult, {
    data: userInfoResult.data && userInfoResult.data.userInfo.portal.enabled_gates.includes(gate)
  }), [gate, userInfoResult]);
};